import { Box, Link, Spinner, Text } from '@chakra-ui/react';
import { useToast } from '@morressier/alembic';
import { useState } from 'react';
import { fetchSubmissionDetailedCheckReport } from 'src/api/queries';
import ProtectedActionButton from 'src/components/ProtectedAction/Button';

type IProps = {
  submissionId: string;
  checkType: string | undefined;
  runId: string | undefined;
  submissionContextId: string;
  currentState: string;
};
const CheckReportUrl = ({
  submissionId,
  checkType,
  runId,
  submissionContextId,
  currentState
}: IProps) => {
  const [loading, setLoading] = useState<boolean>(false);
  const toast = useToast();
  const handleGenerateReport = async () => {
    setLoading(true);
    try {
      const ReportData = await fetchSubmissionDetailedCheckReport(
        submissionId,
        checkType,
        runId
      );
      const disposition = ReportData.headers['content-disposition'];
      const filename = disposition
        ? disposition.split('filename=')[1]?.replace(/"/g, '')
        : 'report.pdf';
      const blob = new Blob([ReportData.data], {
        type: 'application/pdf'
      });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      // Cleanup
      link.remove();
      window.URL.revokeObjectURL(link.href);
    } catch (error) {
      toast({
        variant: 'error',
        title: 'Error While Downloading Detailed Report',
        description: 'Please try again later!',
        isClosable: true
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading ? (
        <Spinner marginLeft={1} size="xs"></Spinner>
      ) : (
        <Box fontSize={'small'}>
          <Text
            textStyle={'textContext'}
            marginLeft={1}
            as={'span'}
            fontWeight={'light'}
          >
            {'See Detailed Report'}
          </Text>
          <ProtectedActionButton
            relation="decision_maker"
            entityType="journal_phase"
            entityId={`${submissionContextId}_${currentState}`}
            size="context"
            variant="primary"
            as="text"
            padding={0}
            height={'fit-content'}
            textStyle={'textContext'}
            fontSize={'small'}
          >
            <Link
              color="blue.500"
              isExternal
              display="inline-block"
              onClick={handleGenerateReport}
              marginBottom={'0.5'}
            >
              Here
            </Link>
          </ProtectedActionButton>
        </Box>
      )}
    </>
  );
};

export default CheckReportUrl;
